export class AddCashReportRequest {
  cashboxId!: number;
  fromDate!: string;
  toDate!: string;
}
